import React from "react";
import EvacuadosPorProvinciaTmp from '../../../containers/EvacuadosPorProvincia';
import { CAMPAIGN_2020 } from '../../../constants';

const EvacuadosPorProvincia = () => {

  return <EvacuadosPorProvinciaTmp campaign={CAMPAIGN_2020} year={2020}/>;
};

export default EvacuadosPorProvincia;
